import { ICase, IDocumentFields } from "../interfaces/ICase";
import { IDoctorsState } from "../interfaces/IDoctor";
import { IHospital } from "../interfaces/IHospital";
import { IFetchAllDetails, IPatient } from "../interfaces/IPatient";
import { IUploadReferral } from "../interfaces/IReferral";
import { IPatientScheme, IScheme } from "../interfaces/IScheme";

export type AddPatientSchemeProps = {
  handleSchemeChange: any;
  schemeData: Array<IScheme>;
  schemeStatus: string;
  schemeStatusChange: any;
  handlePostPatientScheme: CallableFunction;
  isUpdateScheme: boolean;
  updateSchemeValues: any;
  handleUpdatePatientScheme: CallableFunction;
  patientDetail: IPatient | null;
};

export type colorCoding = {
  bgColorName: string;
  bgHexCode: string;
  durationInMinutes: string;
  id: number;
  textColorName: string;
  textHexCode: string;
};

export type PatientCardProps = {
  id: number;
  index: number;
  patientList: { [key: number]: IPatient };
  changeSelectedPatient: CallableFunction;
  handleGetLastCase: CallableFunction;
  handleNavigate: CallableFunction;
  handleNavigateToStage: any;
  expandedCardIndex: number | null;
  setExpandedCardIndex: React.Dispatch<React.SetStateAction<number | null>>;
  auth: any;
};

export type VisitHistoryCardProps = {
  visit: any;
  handleNavigate: CallableFunction;
  handleNavigateToPreAuth: CallableFunction;
};

export type PatientDetailsProps = {
  flag: boolean;
  selectedPatient: IFetchAllDetails | null;
  isFetchingPatient: boolean;
  error: string | null;
  onTabChange: ((activeKey: string) => void) | undefined;
  patientCases: Array<ICase>;
  readOnly: boolean;
  toggleReadOnly: CallableFunction;
  upDateDetails: CallableFunction;
  patientSchemes: Array<any>;
  calculateAge: CallableFunction;
  handleCaseSelect: CallableFunction;
  selectedHospital: IHospital | null | undefined;
  isLoading: boolean;
  justify: any;
  handleEditClick: CallableFunction;
  clearReferralDetails: any;
  handleDeficiencyModal?: any;
  closeDeficiencyModal?: any;
  deficiencyModal: boolean;
  deficiencyQuestions?: any;
  selectedDocument: IDocumentFields | null;
  handleDownloadDocument?: any;
  isDownloadingDocument?: boolean;
  downloadingDocumentUrl?: string;
  previewDocumentUrl: string;
  handleOpen?: CallableFunction;
  showDoc?: CallableFunction;
  handleDoctorSearch: CallableFunction;
  availableDoctor: Array<IDoctorsState>;
  searchLoading: boolean;
  handleNavigate: CallableFunction;
  handleCreditClickModal?: any;
  handleUpdatePatientScheme: CallableFunction;
  handleUpdatePatientDetails: CallableFunction;
  showModal: any;
  previewDocument: boolean;
  setPreviewDocument: React.Dispatch<React.SetStateAction<boolean>>;
  documentUrl: string;
  zoomLevel: number;
  handleZoomIn: () => void;
  handleZoomOut: () => void;
  handleCancelPreview: () => void;
  getFileType: (url: string) => string;
  fetchStepper: CallableFunction;
  handleActivateDeactivate: any;
  isActiveDeactiveModal: boolean;
  setIsActiveDeactiveModal: CallableFunction;
  handleOk: () => void;
  handleCancelConfirmationModal: () => void;
  isSubmitting: boolean;
  newSteps?: any;
  handleCreateEnhancement?: any;
  handleCreateQuery?: any;
  viewAddedEnhancement?: any;
  handleSetActiveStage?: any;
  isFetchingStepperData?: boolean;
  handleResubmission?: any;
  viewResubmission?: any;
};

export type PatientDetailsFormProps = {
  flag: boolean;
  selectedPatient: IFetchAllDetails | null;
  readOnly: boolean;
  toggleReadOnly: CallableFunction;
  upDateDetails: CallableFunction;
  calculateAge: CallableFunction;
  selectedHospital: IHospital | null | undefined;
  isLoading: boolean;
  justify: any;
  clearReferralDetails: any;
  handleDeficiencyModal?: any;
  closeDeficiencyModal?: any;
  deficiencyModal: boolean;
  deficiencyQuestions?: any;
  selectedDocument: IDocumentFields | null;
  handleDownloadDocument?: any;
  isDownloadingDocument?: boolean;
  downloadingDocumentUrl?: string;
  previewDocumentUrl: string;
  handleOpen?: CallableFunction;
  showDoc?: CallableFunction;
  handleDoctorSearch: CallableFunction;
  availableDoctor: Array<IDoctorsState>;
  searchLoading: boolean;
  handleNavigate: CallableFunction;
  handleCreditClickModal?: any;
  handleUpdatePatientScheme: CallableFunction;
  handleUpdatePatientDetails: CallableFunction;
  showModal: any;
  previewDocument: boolean;
  setPreviewDocument: React.Dispatch<React.SetStateAction<boolean>>;
  documentUrl: string;
  zoomLevel: number;
  handleZoomIn: () => void;
  handleZoomOut: () => void;
  handleCancelPreview: () => void;
  getFileType: (url: string) => string;
  fetchStepper: CallableFunction;
  handleActivateDeactivate: any;
  isActiveDeactiveModal: boolean;
  setIsActiveDeactiveModal: CallableFunction;
  handleOk: () => void;
  handleCancelConfirmationModal: () => void;
  isSubmitting: boolean;
  newSteps?: any;
  handleCreateEnhancement?: any;
  handleCreateQuery?: any;
  viewAddedEnhancement?: any;
  handleSetActiveStage?: any;
  handleResubmission?: any;
  viewResubmission?: any;
};

export type PatientListProps = {
  patientIds: Array<number>;
  allPatients: { [key: number]: IPatient };
  isFetchingAllPatients: boolean;
  changeSelectedPatient: CallableFunction;
  currentPage: number;
  totalPatients: number;
  handlePageChange: CallableFunction;
  handleGetLastCase: CallableFunction;
  handleNavigate: CallableFunction;
  handleNavigateToStage: any;
  auth: any;
  pageSize: number;
  onShowSizeChange: (currentPage: any, pageSize: number) => void;
  handleDownloadDocument?: any;
  isDownloadingDocument?: boolean;
  downloadingDocumentUrl?: string;
  handleSetDocumentUrl?: any;
  selectedColumnKeys?: string[];
  handleOpen?: any;
  handleOpenReplyQueryModal?: any;
  fetchTimeline?: any;
};

export type IVisitListProps = {
  isFetchingAllVisits: boolean;
  visitData: any;
  handlePageChange: any;
  totalVisits: number | null;
  handleNavigate: CallableFunction;
  currentPage: number;
  handleNavigateToPreAuth: CallableFunction;
};

export type PatientSchemeListProps = {
  data: Array<IPatientScheme> | undefined;
  isFetchingAllPatientSchemeList: boolean | undefined;
  handleEditClick: CallableFunction;
  scrollToTarget?: () => void;
};

export type AddPatientFormProps = {
  documentTypes: Array<any>;
  documentType: string | undefined;
  setDocumentType: CallableFunction;
  selectedFile: IUploadReferral | undefined;
  listOfResponseUrl: IDocumentFields | undefined;
  uploadFileModal: boolean;
  setUploadFileModal: CallableFunction;
  handleSelectChange: any;
  handleFileChange: any;
  viewFile: CallableFunction;
  handleSaveReferral: CallableFunction;
  patientDetails: any;
  schemeData: Array<any>;
  handleSchemeChange: any;
  schemeSelected: string | null | undefined;
  handleSubmitPatient: CallableFunction;
  calculateAge: CallableFunction;
  secondaryMobileOnWhatsApp: boolean;
  primaryMobileOnWhatsApp: boolean;
  primaryMobileChange: any;
  secondaryMobileChange: any;
  open: boolean;
  handleConfirm: any;
  handleCancel: any;
  extractTextBeforePlus: CallableFunction;
  handleGetPatientFromPortal: CallableFunction;
  isConfirmationModal: boolean;
};

export type FieldType = {
  fullName?: string | null | undefined;
  dob?: string | null | undefined;
  age?: number | null | undefined;
  email?: string | null | undefined;
  primaryMobile?: string | null | undefined;
  secondaryMobile?: string | null | undefined;
  secondaryMobileOnWhatsApp?: boolean;
  sex?: string | null | undefined;
  status?: string | undefined;
  primaryMobileOnWhatsApp?: boolean;
  isPrimaryPolicyHolder?: boolean | null;
  communicationConsent?: boolean | null;
  primaryMobilePrefix?: string | undefined;
  secondaryMobilePrefix?: string;
  identifyNumber?: string | null;
  patientName?: string | null;
  visitType?: string;
  dateTime?: string;
  opNumber?: string;
  department?: Array<string> | null;
  doa?: string | null;
  dod?: string | null;
  doctorDetails?: string;
  totalBillAmount?: string;
  roomNumber?: string;
  doctorId?: number | null;
  doctorName?: string;
  caseTypes?: string;
  patientSchemes?: string;
  uhidNo?: string;
  referralNo?: string;
  referralExpiryFrom?: string | null;
  referralExpiryTo?: string | null;
  noOfVisits?: string | null;
  referringDoctor?: string;
  referralFor?: string | null;
  referralType?: string | null;
  cardCategory?: string | null;
  cardNumber?: string;
  serviceNumber?: string;
  ariAndSC?: boolean;
  clinicalNotes?: string | null;
  admission?: string | null;
  consultationFor?: string | null;
  investigation?: string | null;
  ipAllowed?: boolean;
  polyClinic?: string | null;
  beneficiaryId?: string;
  name?: string | null;
  refferenceID?: string | null;
  dateIssued?: string;
  tokenNumber?: string | null;
  gender?: string | null;
  timeIssued?: string | null;
  referralBy?: string | null;
  remark?: string | null;
};
export const initialValues: any = {
  fullName: "",
  dob: null,
  age: null,
  email: "",
  primaryMobile: "",
  secondaryMobile: "",
  secondaryMobileOnWhatsApp: false,
  sex: "",
  status: "ACTIVE",
  primaryMobileOnWhatsApp: true,
  communicationConsent: true,
  isPrimaryPolicyHolder: true,
  visitType: "",
  dateTime: "",
  department: null,
  opNumber: "",
  doa: null,
  dod: null,
  doctorDetails: "",
  totalBillAmount: "",
  roomNumber: "",
  doctorId: null,
  doctorName: "",
  caseTypes: "",
  patientSchemes: "",
  uhidNo: "",
};

export type PatientCardsProps = {
  fetchPatientDetail: IPatient | undefined;
  handleEditPatient: CallableFunction;
  isEditPatient: boolean;
  handleUpdatePatient: CallableFunction;
  calculateAge: CallableFunction;
  isPatientLoading: boolean;
};
